module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-3.879d9e24.jpg";